import { type ErrorInfo } from 'react';
import { logError } from '#shared/lib/rum';

export function onReactRecoverableError(error: unknown, errorInfo?: ErrorInfo): void {
    try {
        console.error(error);

        const errorToLog =
            error instanceof Error
                ? error
                : {
                      name: 'Error',
                      message: typeof error === 'string' ? error : 'Unknown React recoverable error',
                  };

        logError(
            {
                level: 'error',
                additional: {
                    react_error_handler: 'on_recoverable_error',
                    react_component_stack: errorInfo?.componentStack,
                },
            },
            errorToLog
        );
    } catch {
        // Ошибка логирования не должна мешать восстановлению React.
    }
}
